module.exports = "pegasus/assets/theme2/small/3.jpg";